export interface ExpenseCategoryClass {
    AccountExpenseId : number
    MasterAccountExpenseId : number
    AccountExpenseName:string
    AccountExpenseTypeId:number
    IsBillable:boolean
    DefaultExpenseRate : number
    DisabledEditingOfRate:boolean
    AccountExpenseGuidId:string
    AccountId: number
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    IsDeleted: boolean
    IsDisabled: boolean
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    isSelected:number
}

const common = {    
    AccountExpenseName:"",
    AccountExpenseTypeId:0,
    IsBillable:false,
    DefaultExpenseRate:0,
    DisabledEditingOfRate:false,
    AccountExpenseGuidId:"",
    IsDisabled:false
  };
  
  export const ExpenseCategoryInitialsForAdd = { ...common };
  
  export const ExpenseCategoryInitialsForUpdate = {
    ...common,
    AccountExpenseId:0,
  };



// export const ExpenseCategoryInitialsForApp = {
//     AccountExpenseName:"",
//     AccountExpenseTypeId:0,
//     IsBillable:false,
//     DefaultExpenseRate:0,
//     DisabledEditingOfRate:false,
//     AccountExpenseGuidId:"",
//     IsDisabled:false
// }

// export const ExpenseCategoryInitialsForUpdate = {
//     AccountExpenseId:0,
//     AccountExpenseName:"",
//     AccountExpenseTypeId:0,
//     IsBillable:false,
//     DefaultExpenseRate:0,
//     DisabledEditingOfRate:false,
//     AccountExpenseGuidId:"",
//     ExpenseType:"",
//     IsDisabled:false
// }